import ExchangeProfileBlock from './ExchangeProfileBlock';

export default ExchangeProfileBlock;
